"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserUpdate = exports.removeNullProperties = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const UPDATE_USER_MUTATION_QUERY = (0, graphql_tag_1.default) `
  mutation UserUpdateMutation($id: ID!, $data: UserUpdateInputData!) {
    userUpdate(id: $id, data: $data) {
      id
      email
      birthdate
      dummy
      firstName
      language
      lastMobileAppUse
      lastName
      notificationPreferences {
        channels {
          app {
            enabled
            origins {
              enabled
              name
            }
          }
          email {
            enabled
            origins {
              name
              enabled
            }
          }
          mobile {
            enabled
            origins {
              name
              enabled
            }
          }
        }
      }
      telephone
    }
  }
`;
function removeNullProperties(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => (0, util_1.isNotNull)(value)));
}
exports.removeNullProperties = removeNullProperties;
const requestUserUpdate = async ({ id, data }) => {
    const varsFixed = {
        id,
        data: removeNullProperties(data),
    };
    const { data: mutatedData, errors } = await (0, apollo_1.mutate)(UPDATE_USER_MUTATION_QUERY, {
        variables: varsFixed,
    });
    (0, error_handler_1.processErrors)(errors);
    return mutatedData?.userUpdate;
};
exports.requestUserUpdate = requestUserUpdate;
// async function requestUserUpdate(variables, token) {
//   const varsFixed = { ...variables }
//   Object.keys(varsFixed?.data || {}).forEach((k) => {
//     // none of the props in UserUpdateInputData 'data' allow null value, so we don't send those
//     if (varsFixed.data[k] === null) delete varsFixed.data[k]
//   })
//   const response = await fetchRequest({
//     variables: varsFixed,
//     query: UPDATE_USER_MUTATION_QUERY,
//     token,
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('user-update', errors)
//   }
//   return data.userUpdate
// }
exports.default = exports.requestUserUpdate;
